import React from 'react';
import { useWeddingDay } from '../state/useWeddingDay';

const e = React.createElement;

// The button only. It closes the last section.
const SubmitCard = ({ onOpenSubmit }) => {
  const { doc, locked, sharedLocked, closed, readOnly, canEdit } = useWeddingDay();
  if (readOnly) return null;

  const label = doc.submitted
    ? 'Wedding day details submitted'
    : closed
    ? 'Form closed'
    // Per side, so the wording says whose part this is once the other has gone.
    : sharedLocked
    ? 'Submit your part'
    : 'Submit wedding day details';

  return e('div', { className: 'wd-submitrow' }, [
    e(
      'button',
      {
        key: 'btn',
        type: 'button',
        className: 'wd-btn wd-btn-brand wd-btn-submit',
        // Shown rather than hidden where they cannot submit, so a closed
        // form still says so, but never opens a submit the server refuses.
        disabled: locked || canEdit === false,
        onClick: onOpenSubmit,
      },
      label
    ),
    e(
      'p',
      { className: 'wd-thanks', key: 'thanks' },
      'Thank you. Your answers help our team arrive prepared for your celebrations.'
    ),
  ]);
};

export default SubmitCard;
